











/** @format */

import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import carSignInfo from './components/carSignInfo.vue';
import { LONG_RENTAL_CAR_SIGN } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';

@Component({
  components: { carSignInfo }
})
export default class carSignDetail extends Vue {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  headTitle = '业务详情'; // 标题
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '在线缴费订单管理',
        location: {
          name: LONG_RENTAL_CAR_SIGN
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  ß;

  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: LONG_RENTAL_CAR_SIGN
    });
  }
}
